import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import apiFetch from 'utils/apiFetch';
import Avatar from 'components/Avatar';
import moment from 'moment';
import UserCard from 'components/UserCard';
import { SpeedDatingBarLayer, CloseIcon } from './styles';

class SpeedDatingBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showProfileModal: false,
      actualTime: null,
      hasFinishedMeeting: false,
      canAddMinute: true,
      diffServer: 0,
    };
  }

  componentDidMount() {
    this.getServerTime();
  }

  componentDidUpdate(prevProps) {
    const { hasFinishedMeeting, actualTime } = this.state;
    const { endDate, doFinishMeeting } = this.props;

    if (!hasFinishedMeeting && actualTime && endDate && endDate < actualTime && (actualTime - endDate) < 5) {
      this.finishMeeting();
    }

    if (!prevProps.doFinishMeeting && doFinishMeeting) {
      this.finishMeeting();
    }
  }

  componentWillUnmount() {
    if (this.intActualTime) {
      clearInterval(this.intActualTime);
    }

    if (this.toAddMinute) {
      clearTimeout(this.toAddMinute);
    }
  }

  getServerTime() {
    apiFetch('GET', { endPoint: 'instance/actual_time' })
      .then((response) => {
        const diffServer = moment().unix() - response.actual_time;
        this.setState({ actualTime: response.actual_time, diffServer });

        this.intActualTime = setInterval(this.updateActualTime, 1000);
      });
  }

  handleShowModalFinish = () => {
    const { showModalFinish } = this.props;
    showModalFinish();
  }

  updateActualTime = () => {
    const { diffServer } = this.state;
    const actualTime = moment().unix() - diffServer;
    this.setState({ actualTime });
  }

  finishMeeting = () => {
    const { elementId, meetingId } = this.props;
    const { hasFinishedMeeting } = this.state;
    if (hasFinishedMeeting) {
      return false;
    }

    apiFetch('POST', { endPoint: `speed-dating/${elementId}/finish/${meetingId}` });

    this.setState({ hasFinishedMeeting: true });

    return true;
  }

  handleOpenProfileModal = () => {
    this.setState({ showProfileModal: true });
  }

  handleCloseProfileModal = () => {
    this.setState({ showProfileModal: false });
  }

  printProfileModal = () => {
    const { showProfileModal } = this.state;
    const { userId } = this.props;

    if (!showProfileModal) {
      return null;
    }

    return (
      <Modal
        open={showProfileModal}
        onClose={this.handleCloseProfileModal}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        style={{ zIndex: 1110000 }}
      >
        <div className='modal'>
          <CloseIcon className='fa fa-times' onClick={this.handleCloseProfileModal} />
          <UserCard userId={userId} />
        </div>
      </Modal>
    );
  }

  addMinute = () => {
    const { canAddMinute } = this.state;
    const { elementId, meetingId } = this.props;

    apiFetch('PUT', { endPoint: `narratives/${elementId}/speed-dating/calls/${meetingId}/add-minute` });

    if (canAddMinute) {
      this.setState({ canAddMinute: false });
    }

    this.toAddMinute = setTimeout(this.resetAddMinuteFlag, 15000);
  }

  resetAddMinuteFlag = () => {
    this.setState({ canAddMinute: true });
  }

  printUserData = () => {
    const {
      avatar, name, userId, literals,
    } = this.props;

    return (
      <div className='user_layer'>
        <Avatar size={42} avatar={avatar} firstname={name} id={userId} />
        <div className='username'>
          {name}
        </div>
        <button className='primary btn-sm' onClick={this.handleOpenProfileModal}>{literals.viewProfile}</button>
      </div>
    );
  }

  printCountDown = () => {
    const { endDate, literals } = this.props;
    const { actualTime, canAddMinute } = this.state;

    const diff = Math.max(endDate - actualTime, 0);

    let minutes = Math.floor(diff / 60);
    let seconds = diff % 60;

    if (minutes < 10) {
      minutes = `0${minutes}`;
    }

    if (seconds < 10) {
      seconds = `0${seconds}`;
    }

    if (!endDate) {
      return null;
    }

    return (
      <div className='countdown'>
        <div className='text'>
          {`${literals.timeLeft}:`}
          <b>{`${minutes}:${seconds}`}</b>
        </div>
        {diff > 5 && (
          <React.Fragment>
            {}
            <button className='danger btn-sm' onClick={this.handleShowModalFinish}>{literals.finish}</button>
          </React.Fragment>
        )}
      </div>);
  }

  render() {
    return (
      <React.Fragment>
        <SpeedDatingBarLayer>
          {this.printCountDown()}
          {this.printUserData()}
          <div className='clearfix' />
          {this.printProfileModal()}
        </SpeedDatingBarLayer>
      </React.Fragment>
    );
  }
}

SpeedDatingBar.propTypes = {
  userId: PropTypes.number.isRequired,
  avatar: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  literals: PropTypes.object.isRequired,
  endDate: PropTypes.number.isRequired,
  meetingId: PropTypes.string.isRequired,
  elementId: PropTypes.number.isRequired,
  showModalFinish: PropTypes.func.isRequired,
  doFinishMeeting: PropTypes.bool.isRequired,
};

export default SpeedDatingBar;



// WEBPACK FOOTER //
// ./src/components/ZoomMeeting/components/SpeedDatingBar.jsx